// extracted by mini-css-extract-plugin
export default {"wrapper":"M0-z","play":"N0-z"};